import React from 'react';
import { GlobalStyles, useTheme } from '@mui/material';

// MapLibre and Google both paint the box a card sits in, and both paint it white. The card inside
// is the product's own and follows the theme, so on a dark screen the two disagreed: dark text on
// a white slab with a white tail. These are the few surfaces each library owns, given the paper
// and the divider the rest of the product uses.
const MapPopupTheme = () => {
  const theme = useTheme();
  const { paper } = theme.palette.background;
  const { primary: text, secondary: muted } = theme.palette.text;
  const shadow = theme.palette.mode === 'dark' ? '0 6px 24px rgba(0,0,0,.6)' : '0 6px 24px rgba(0,0,0,.18)';
  return (
    <GlobalStyles
      styles={{
        '.maplibregl-popup-content': {
          background: paper,
          color: text,
          borderRadius: 10,
          boxShadow: shadow,
          padding: 10,
        },
        '.maplibregl-popup-close-button': { color: muted, fontSize: 18 },
        // The tail is drawn as a triangle from a border colour, one rule per direction it points.
        '.maplibregl-popup-anchor-top .maplibregl-popup-tip': { borderBottomColor: paper },
        '.maplibregl-popup-anchor-bottom .maplibregl-popup-tip': { borderTopColor: paper },
        '.maplibregl-popup-anchor-left .maplibregl-popup-tip': { borderRightColor: paper },
        '.maplibregl-popup-anchor-right .maplibregl-popup-tip': { borderLeftColor: paper },
        '.maplibregl-popup-anchor-top-left .maplibregl-popup-tip': { borderBottomColor: paper },
        '.maplibregl-popup-anchor-top-right .maplibregl-popup-tip': { borderBottomColor: paper },
        '.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip': { borderTopColor: paper },
        '.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip': { borderTopColor: paper },
        // Google's info window: the card, its padding wrapper, the tail and the close button.
        '.gm-style .gm-style-iw-c': { background: paper, color: text, boxShadow: shadow },
        '.gm-style .gm-style-iw-d': { background: paper, color: text, overflow: 'auto !important' },
        '.gm-style .gm-style-iw-tc::after': { background: paper },
        '.gm-style .gm-style-iw-c button.gm-ui-hover-effect > span': { backgroundColor: muted },
      }}
    />
  );
};

export default MapPopupTheme;
